import TecNewForm from './TecNew';

export default TecNewForm;
